var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFormBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1170,
    height: 924,
    viewBox: "0 0 1170 924",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149014",
    "data-name": "Rectangle 149014",
    width: 1170,
    height: 735,
    transform: "translate(375 4931)",
    fill: "#0d1267"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FormBG",
    transform: "translate(-375 -4931)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BG_Box",
    "data-name": "BG Box",
    width: 1170,
    height: 924,
    transform: "translate(375 4931)",
    fill: "#0d1267"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Circle",
    transform: "translate(0 189)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_367",
    "data-name": "Ellipse 367",
    cx: 396,
    cy: 396,
    r: 396,
    transform: "translate(248 5073)",
    fill: "#f86635"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormBg);
export default __webpack_public_path__ + "static/media/FormBG.0cff4eca31be75b8be60723c752d3bbb.svg";
export { ForwardRef as ReactComponent };